import { render } from "./Modal.vue?vue&type=template&id=0a588dc0&scoped=true&lang=pug"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=0a588dc0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0a588dc0"

export default script